/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ChangeScope = {
    Contract: 'Contract',
    Client: 'Client'
} as const;
export type ChangeScope = typeof ChangeScope[keyof typeof ChangeScope];


export function instanceOfChangeScope(value: any): boolean {
    for (const key in ChangeScope) {
        if (Object.prototype.hasOwnProperty.call(ChangeScope, key)) {
            if (ChangeScope[key as keyof typeof ChangeScope] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ChangeScopeFromJSON(json: any): ChangeScope {
    return ChangeScopeFromJSONTyped(json, false);
}

export function ChangeScopeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangeScope {
    return json as ChangeScope;
}

export function ChangeScopeToJSON(value?: ChangeScope | null): any {
    return value as any;
}

export function ChangeScopeToJSONTyped(value: any, ignoreDiscriminator: boolean): ChangeScope {
    return value as ChangeScope;
}

